import { EMPTY_ASSIGN_INVOICE_CRITERIA_MODEL } from "presentation/model/AssignInvoiceCriteria/AssignInvoiceCriteriaModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: AssignInvoiceCriteriaProvider,
    useTracked: useAssignInvoiceCriteriaTracked
} = createContainer(() => useState(EMPTY_ASSIGN_INVOICE_CRITERIA_MODEL), { concurrentMode: true });
export { AssignInvoiceCriteriaProvider, useAssignInvoiceCriteriaTracked };

